import { Img } from '@/components/blocks/MaterialImage';
import { SxProps, Theme } from '@mui/material';
import { CDN_BASE_URL } from 'shared/custom/constants/commonConstants';

type CardImageType = {
	url: string;
	width: number;
	height: number;
	alt: string;
	className?: string;
	sx?: SxProps<Theme>;
};
export const FALLBACK_URL = `${CDN_BASE_URL}/assets/img/imagen-no-disponible.svg`;

export const CardImage = ({ url, width, height, alt, className, sx }: CardImageType) => (
	<Img
		width={width}
		height={height}
		src={url}
		alt={alt}
		className={className}
		sx={sx}
		onError={(e) => (e.currentTarget.src = FALLBACK_URL)}
	/>
);
